import React from "react";

const NAV_TYPES = new Set(["first_page", "last_page", "prev_page", "next_page"]);

export default function Pagination(props) {
  const data = props.data;

  const onPageChange = (page) => {
    if (props.onPageChange && page) {
      props.onPageChange(page);
    }
  };

  if (!data || !data.length) {
    return null;
  }

  const renderLabel = (pageData) => {
    switch (pageData.type) {
      case "prev_page":
        return <i className="fas fa-angle-left" aria-hidden="true" />;
      case "next_page":
        return <i className="fas fa-angle-right" aria-hidden="true" />;
      case "first_page":
        return <i className="fas fa-angle-double-left" aria-hidden="true" />;
      case "last_page":
        return <i className="fas fa-angle-double-right" aria-hidden="true" />;
      default:
        return <span>{pageData.label}</span>;
    }
  };

  return (
    <nav className="paginationArea" aria-label="Pagination">
      <ul className="pagination">
        {data.map((pageData, index) => {
          const isNav = NAV_TYPES.has(pageData.type);
          const isCurrent = pageData.type === "current_page";
          const isEllipsis =
            pageData.type === "ellipsis" ||
            pageData.label === "..." ||
            pageData.label === "…";

          const classNames = ["page-link"];
          if (isCurrent) {
            classNames.push("current-page");
          }
          if (isNav) {
            classNames.push("icon-page");
          }
          if (isEllipsis) {
            classNames.push("ellipsis-page");
          }

          const canNavigate = Boolean(pageData.page) && !isEllipsis;

          return (
            <li key={`${pageData.type}-${pageData.page ?? pageData.label}-${index}`} className="page-item">
              <button
                type="button"
                className={classNames.join(" ")}
                disabled={!canNavigate}
                aria-current={isCurrent ? "page" : undefined}
                aria-label={
                  isNav
                    ? pageData.type.replace("_", " ")
                    : isCurrent
                      ? `Page ${pageData.label}, current`
                      : `Page ${pageData.label}`
                }
                onClick={() => canNavigate && onPageChange(pageData.page)}
              >
                {renderLabel(pageData)}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
